import Router from 'vue-router'

import employeeRoutes from './employeesRoutes.js'
import companyRoutes from './companyRoutes'

import subscriptionRoutes from './subscriptionRoutes'

import invoicesRoutes from './invoicesRoutes'

import Timetracker from '../components/routes/timetracking/Timetracker'
import Referrals from '../components/routes/referrals/Referrals.vue'
import settingsRoutes from './settingsRoutes.js'

import unprotectedRoutes from './unprotectedRoutes.js'

import store from '../store/store'
import { ability } from '../permissions/rules'
import { setI18nLanguage } from '@/locales/i18n-setup'
import archivesRoutes from '@/router/archivesRoutes'

const isAuth = () => store.getters['user/isAuth']
const getUser = () => store.getters['user/getUser']

const router = new Router({
  mode: 'history',
  routes: [
    ...unprotectedRoutes,
    ...settingsRoutes,
    ...employeeRoutes,
    ...companyRoutes,
    ...subscriptionRoutes,
    ...invoicesRoutes,
    ...archivesRoutes,
    {
      name: 'timetracking',
      path: '/timetracking',
      component: Timetracker
    },
    {
      name: 'referrals',
      path: '/referrals',
      component: Referrals
    }
  ],

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  const authRequired = to.matched.some(record => !record.meta.ignoreAuth)
  if (authRequired && !isAuth()) {
    next({ name: 'login' })
  } else if (!authRequired) {
    next()
  } else {
    // Before auth app routing

    // 1. Check if user can access route depend on role
    const canEnterRoute = to.matched.some(record =>
      ability.can('enterRoute', record.name)
    )

    // 2. Check and set user preferred language
    setI18nLanguage(getUser().lang.name)

    if (process.env.NODE_ENV === 'development' && !canEnterRoute) {
      console.error(`User has no access to route [${to.path}]`)
    }

    next(canEnterRoute ? true : { name: 'home' })
  }
})

export default router
